import { Text, View } from "@react-pdf/renderer"
import { InitialPallets } from "../../interfaces/intakes.reports"
import { globalStyles } from "../pdf/DocuPdf"

interface Props {
    pallet: InitialPallets
    isDisabled?: boolean
    isPDF?: boolean
}

export const PalletOrSampleNumber = ({ pallet, isDisabled, isPDF }: Props) => {

    return (
        <>
            {
                isPDF
                    ?
                    <View style={[globalStyles.flexRow]}>
                        <Text style={[globalStyles.bold, { marginRight: 5, fontSize: "14px", color: "#353644" }]}>{pallet.pallet_sample ? "Sample" : "Pallet"}</Text>
                        {
                            pallet.pallet &&
                            <View style={{ backgroundColor: "#353644", height: 14, width: 14, borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center" }}>
                                <Text style={[globalStyles.bold, { fontSize: "10px", color: "white" }]}>{pallet.pallet_sample ? pallet.pallet_sample : pallet.pallet}</Text>
                            </View>
                        }
                    </View>
                    :
                    <>
                        <h3 className={`tw-mr-2 font-medium ${isDisabled && "text-mute"}`}>{pallet.pallet_sample ? "Sample" : "Pallet"}</h3>
                        {pallet.pallet && <span className={`index-number ${isDisabled && "index-deactivate"}`}>{pallet.pallet_sample ? pallet.pallet_sample : pallet.pallet}</span>}
                    </>
            }
        </>
    )
}
